import styled from 'styled-components';

export const DropdownItem = styled.div`
  height: 34px;
  padding: 10px 17px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text.actionDropDownItem};
  font-size: 12px;
  font-weight: 300;

  svg {
    position: relative;
    margin-right: 15px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.backgrounds.actionDropDownHover};
    font-weight: 600;
  }
`;
DropdownItem.displayName = 'DropdownItem';

export const Wrapper = styled.div`
  position: relative;
`;
Wrapper.displayName = 'Wrapper';

export const Dropdown = styled.div`
  position: absolute;
  width: 244px;
  max-height: 220px;
  overflow-y: auto;
  border-radius: 3px;
  box-shadow: 2px 2px 30px 0 ${({ theme }) => theme.shadows.actionDropDown};
  border: solid 1px ${({ theme }) => theme.borders.actionDropDown};
  background-color: ${({ theme }) => theme.backgrounds.actionDropDown};
  padding: 3px 4px;
  z-index: 1000;
`;
